import { BindingCreator } from '@dreryk/react-common';
import { BankAccountNumberInput } from '@dreryk/react-components';

export const BANK_ACCOUNT_NUMBER_FIELD_NAME = 'bankAccountNumber';
const BANK_ACCOUNT_NUMBER_MAX_LENGTH = 26;

export type BankAccountNumberFormBeanPart = {
   [BANK_ACCOUNT_NUMBER_FIELD_NAME]: string;
};

type BankAccountNumberFieldProps = {
   readonly register: BindingCreator<BankAccountNumberFormBeanPart, typeof BANK_ACCOUNT_NUMBER_FIELD_NAME>;
};

export const BankAccountNumberField = (props: BankAccountNumberFieldProps): JSX.Element => {
   return (
      <BankAccountNumberInput
         controller={props.register(BANK_ACCOUNT_NUMBER_FIELD_NAME, {
            required: true,
            maxLength: BANK_ACCOUNT_NUMBER_MAX_LENGTH,
         })}
         testId={BANK_ACCOUNT_NUMBER_FIELD_NAME}
      />
   );
};
